/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "inflows": {
        "nested": {
          "InstantAccessProgram": {
            "nested": {
              "Platform": {
                "values": {
                  "UNKNOWN_PLATFORM_DO_NOT_USE": 0,
                  "DOORDASH": 1,
                  "UBER_EATS": 2,
                  "GRUBHUB": 3
                }
              },
              "OptInMechanism": {
                "values": {
                  "UNKNOWN_OPT_IN_MECHANISM_DO_NOT_USE": 0,
                  "ALPHA_UNIT": 1,
                  "RST_PREM_PLUS_ONBOARDING": 2,
                  "TEST_ACCOUNT": 3,
                  "BETA_UNIT": 4,
                  "FIRST_PARTY_INTEGRATION": 5
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram?.nested?.Platform && !$root.nested?.squareup?.nested?.inflows?.nested?.InstantAccessProgram?.nested?.OptInMechanism) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstantAccessProgram @ squareup/inflows/instant_access_program_model.proto at 11:1
 */
export const InstantAccessProgram = {};
/**
 * SOURCE Platform @ squareup/inflows/instant_access_program_model.proto at 28:3
 */
InstantAccessProgram.Platform = $root.lookupEnum('squareup.inflows.InstantAccessProgram.Platform').values;
/**
 * SOURCE OptInMechanism @ squareup/inflows/instant_access_program_model.proto at 38:3
 */
InstantAccessProgram.OptInMechanism = $root.lookupEnum('squareup.inflows.InstantAccessProgram.OptInMechanism').values;